exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-0d2a8d86] {\n  font-weight: bold;\n  font-size: 12px;\n}\nspan[data-v-0d2a8d86] {\n  font-weight: 550;\n  font-size: 11px;\n}\n.v-form > .container > .layout > .flex[data-v-0d2a8d86] {\n  padding: 2px;\n  font-size: 11px;\n}\np.centrado[data-v-0d2a8d86] {\n  font-size: 12px;\n  font-weight: normal;\n  text-align: center;\n}\n", ""]);

// exports
